import Vue from 'vue'
import '@/config'


import App from './App.vue'
import router from './router'
import store from './store'
import initDirective from './components/directives/mode'

import '@/assets/less'

initDirective(Vue);

Vue.config.productionTip = false
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


